import { browserHistory } from 'react-router';
import Axios from './../common/helpers/axiosUtil';
import * as ActionTypes from './actionTypes';
import * as navigationHelper from './../common/helpers/navigationHelper';
import * as ACL from '../common/helpers/ACL';
import { setBPUserAuthDetails } from '../header/actions';
import { getBrandConfigs } from './../../config/brand-configs';
import { hasToForceUserToSignForms } from '../common/commomUtil';
import bpClientLogger from '../common/helpers/bpClientLogger';
import * as apiHelper from '../common/helpers/apiHelper';

export function updateComponentState(type, payload) {
  return { type, payload };
}

export function setBPUserAccessLevels(type, payload) {
  return dispatch => {
    dispatch(updateComponentState(type, payload));
  };
}

export function setLDFlags(flags) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SET_LD_FLAGS, { ldFlags: flags }));
  };
}

export function setBrandConfigurations(brand) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SET_BRAND_CONFIGS, { bpBrandFeatures: getBrandConfigs(brand) }));
  };
}

export const fetchAppointmentsToSignForms = () =>
  Axios.post(`/apps/ptb/api/appointments/formsList`, {
    type: `broker`,
    filterBy: {
      brokerStatus: `In Progress`,
      isUserForceToSignForms: true,
    },
  }).catch(err => bpClientLogger.error(`Error fetching mandatory appointment list. Reason: ${JSON.stringify(err)}`));

export const fetchUserMandatoryAppointments = () => dispatch =>
  fetchAppointmentsToSignForms().then(appointmentList =>
    dispatch(
      updateComponentState(ActionTypes.HOME_SET_MANDATORY_APPOINTMENT_INFO, appointmentList?.appointmentdetails || [])
    )
  );

export function fetchLoggedInUserProfile(
  path,
  isSimulation = false,
  stopPropogation = false,
  queryParams,
  configs = {},
  appointmentsFetchPromise
) {
  return dispatch => {
    return Axios.get('/apps/ptb/api/userprofile')
      .then(data => {
        // For Delegate with Single Assigned Agent, We have to re-fetch new oAuth Token for selected taxID.
        const { producer, userType, isDelegateWithSingleAssignedAgent = false } = data?.profile || {};
        if (['delegate', 'siteadministrator'].includes(userType.toLowerCase()) && isDelegateWithSingleAssignedAgent) {
          const selectedTaxId = producer?.encryptedTaxId;
          dispatch(setBPUserAuthDetails({ selectedTaxId }));
          return apiHelper.getBPUserToken(true).then(() => data);
        }
        return data;
      })
      .then(
        // On success response
        async data => {
          // TODO BPP-81122 - Temporary fix for Login issue.

          // if (data.secretQuestionAnswers && data.secretQuestionAnswers.length === 0){
          //   dispatch(updateComponentState(ActionTypes.SHOW_SQ_SIDEBAR, {isSqSidebarShown : true}));
          // }
          // Is BPR logged in always through simulation?
          // It is technically possible to visit /apps/ptb/ if user has proper access!!!
          const loggedInUserInfo = data;
          const taxId = loggedInUserInfo?.profile?.producer?.encryptedTaxId;

          let enforceToSignForms = false;
          if (appointmentsFetchPromise) {
            try {
              const appointments = await appointmentsFetchPromise;
              enforceToSignForms = hasToForceUserToSignForms(appointments?.payload, data?.profile);
            } catch (err) {
              bpClientLogger.error(`Error fetching mandatory appointment list. Reason: ${JSON.stringify(err)}`);
            }
          }

          dispatch(
            updateComponentState(
              isSimulation ? ActionTypes.HOME_SET_SIMULATIONUSER_INFO : ActionTypes.HOME_SET_LOGGEDINUSER_INFO,
              { data, isBusy: true }
            )
          );

          // storing accessModules
          const { accessLevel, userType, userId } = loggedInUserInfo?.profile;
          const { type } = loggedInUserInfo?.profile?.producer;
          const accessModules = ACL.accessControlList(accessLevel, userType, type);

          dispatch(updateComponentState(ActionTypes.USER_ACCESS_LEVELS, { userAccessModules: accessModules }));

          if (!isSimulation) {
            // set this flag only when this is not in simulation mode, otherwise, we will end up overwriting the window.simulationHeader
            // added from PTB
            window.isSimulation = false;
          }

          if (!stopPropogation) {
            if (enforceToSignForms || data?.profile?.userType === `AppointmentInitiator`) {
              navigationHelper.goToActivePage(`accountdetails`, taxId, accessLevel, userId, queryParams, configs);
            } else if (!path && data.profile.assignedAgents) {
              // this is called from Home Controller while building userprofile from cookies (traversing from Angular)
              browserHistory.push('/apps/ptb/switchbroker');
            } else if (path && taxId) {
              navigationHelper.goToActivePage(path, taxId, accessLevel, userId, queryParams, configs);
            } else {
              navigationHelper.goToHomePage(taxId, accessLevel, userId, configs);
            }
          }
          return data; // BPP-151292: Enforcing stopPropogation in SFDC->PTB Bridge->ATK flow for IND quoting, to ensure broker profile is returned from Redux actions.
        }
      );
  };
}

export function fetchAceProfile(userId) {
  return dispatch => {
    let currentYear = new Date().getFullYear().toString();
    let url = `/apps/ptb/api/ace/profile?year=${currentYear}`;

    return Axios.get(url)
      .then(data => {
        let bpUserAceProfile = { isEliteBroker: false, profiles: [] };
        if (data && data.aceProfile) {
          let currentYearAceProfile = data.aceProfile.find(profile => profile.year === currentYear);
          if (currentYearAceProfile && currentYearAceProfile.profiles) {
            let eliteStatusProfile = currentYearAceProfile.profiles.find(
              profile => profile.status && profile.status.trim().toLowerCase() === 'elite'
            );
            bpUserAceProfile.isEliteBroker = !!eliteStatusProfile;
            bpUserAceProfile.profiles = currentYearAceProfile.profiles;

            let nonEliteStatusProfile = currentYearAceProfile.profiles.find(
              profile => !profile.status || profile.status.trim().toLowerCase() !== 'elite'
            );

            bpUserAceProfile.isEliteBrokerForAllStates = !nonEliteStatusProfile;
          }
        }
        dispatch(updateComponentState(ActionTypes.HOME_SET_ACE_PROFILE, { bpUserAceProfile }));
        return data;
      })
      .catch(() => {
        dispatch(updateComponentState(ActionTypes.HOME_FETCH_ACE_PROFILE_FAILED));
      });
  };
}

export function fetchAceConciergeDetail(assetIdList) {
  return dispatch => {
    let url = `/apps/ptb/api/ace/concierge/detail?assetIDs=${assetIdList.map(id => 'profile:' + id).join(',')}`;
    return Axios.get(url)
      .then(data => {
        dispatch(updateComponentState(ActionTypes.HOME_ACE_SET_CONCIERGE_DETAIL, data));
        return data;
      })
      .catch(() => {
        dispatch(updateComponentState(ActionTypes.HOME_ACE_FETCH_CONCIERGE_DETAIL_FAILED));
      });
  };
}

export function resetSimulationProfile() {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.HOME_RESET_SIMULATIONUSER_INFO, {}));
  };
}

export function fetchUserProfile(path, appointmentsFetchPromise) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.HOME_AUTHENTICATE_USER, { isBusy: true }));
    Axios.get('/apps/ptb/api/userProfile')
      .then(data => {
        // For Delegate with Single Assigned Agent, We have to re-fetch new oAuth Token for selected taxID.
        const { producer, userType, isDelegateWithSingleAssignedAgent = false } = data?.profile || {};
        if (['delegate', 'siteadministrator'].includes(userType.toLowerCase()) && isDelegateWithSingleAssignedAgent) {
          const selectedTaxId = producer?.encryptedTaxId;
          dispatch(setBPUserAuthDetails({ selectedTaxId }));
          return apiHelper.getBPUserToken(true).then(() => data);
        }
        return data;
      })
      .then(async data => {
        let enforceToSignForms = false;
        if (appointmentsFetchPromise) {
          try {
            const appointments = await appointmentsFetchPromise;
            enforceToSignForms = hasToForceUserToSignForms(appointments?.payload, data?.profile);
          } catch (err) {
            bpClientLogger.error(`Error fetching mandatory appointment list. Reason: ${JSON.stringify(err)}`);
          }
        }
        // Is BPR logged in always through simulation?
        // It is technically possible to visit /apps/ptb/ if user has proper access!!!
        const userDetails = data.simulationUserDetails || data.loggedInUserDetails;
        const taxId = userDetails.profile.producer.encryptedTaxId;

        // if (userDetails.isInternalUser && userDetails.canSimulate) {
        //     navigationHelper.goToUserSimulationPage();
        //     return;
        // }
        dispatch(
          updateComponentState(ActionTypes.HOME_AUTHENTICATE_USER, { userProfile: { data: data }, isBusy: true })
        );

        // storing accessModules
        const { accessLevel, userType, userId } = userDetails.profile;
        const { type } = userDetails.profile.producer;
        const accessModules = ACL.accessControlList(accessLevel, userType, type);
        dispatch(updateComponentState(ActionTypes.USER_ACCESS_LEVELS, { userAccessModules: accessModules }));

        if (path && taxId) {
          navigationHelper.goToActivePage(
            enforceToSignForms || userType === `AppointmentInitiator` ? `accountdetails` : path,
            taxId,
            accessLevel,
            userId
          );
        }
      })
      .catch(error => {
        dispatch(updateComponentState(ActionTypes.HOME_AUTHORIZATION_ERROR, { userProfile: { error: error } }));
      })
      .then(() => {
        dispatch(updateComponentState(ActionTypes.HOME_AUTHENTICATE_USER, { isBusy: false }));
      });
  };
}

export function fetchUserSimulationProfile(
  userid,
  path,
  stopPropogation = false,
  queryParams,
  configs = {},
  producerIdentifier = null,
  appointmentsFetchPromise
) {
  return async dispatch => {
    let endpoint = '/apps/ptb/api/user/secure';
    return Axios.post(endpoint, { userid: userid, producerIdentifier: producerIdentifier })
      .then(data => {
        // We are keeping the encrypted/tokenized user-id in session storage to support simulation flow in SET application.
        sessionStorage.setItem('bpUserId', data?.tokenized?.userId);
        // For Delegate with Single Assigned Agent, We have to re-fetch new oAuth Token for selected taxID.
        const { producer, userType, isDelegateWithSingleAssignedAgent = false } = data?.profile || {};
        if (['delegate', 'siteadministrator'].includes(userType.toLowerCase()) && isDelegateWithSingleAssignedAgent) {
          const selectedTaxId = producer?.encryptedTaxId;
          dispatch(setBPUserAuthDetails({ selectedTaxId }));
          return apiHelper.getBPUserToken(true).then(() => data);
        }
        return data;
      })
      .then(async data => {
        let enforceToSignForms = false;
        if (appointmentsFetchPromise) {
          try {
            const appointments = await appointmentsFetchPromise;
            enforceToSignForms = hasToForceUserToSignForms(appointments?.payload, data?.profile);
          } catch (err) {
            bpClientLogger.error(`Error fetching mandatory appointment list. Reason: ${JSON.stringify(err)}`);
          }
        }
        // Is BPR logged in always through simulation?
        // It is technically possible to visit /apps/ptb/ if user has proper access!!!
        const userDetails = data;
        if (!isProducerLicenseDetailsValid(userDetails)) return Promise.reject({ invalidLicenseDetail: true });

        const taxId = userDetails.profile.producer.encryptedTaxId;
        const simulationHeader = `?simulationUserId=${data.encryptedUserId_Aes128}`;
        dispatch(updateComponentState(ActionTypes.HOME_SET_SIMULATIONUSER_INFO, { data, simulationHeader }));

        // storing accessModules
        const { accessLevel, userType, userId } = userDetails.profile;
        const { type } = userDetails.profile.producer;
        const accessModules = ACL.accessControlList(accessLevel, userType, type);
        dispatch(updateComponentState(ActionTypes.USER_ACCESS_LEVELS, { userAccessModules: accessModules }));

        // for SSOs backward compatibility, we need to set the encrypted user id in to simulation header
        window.isSimulation = true;
        window.simulationHeader = simulationHeader;

        dispatch(
          updateComponentState(ActionTypes.PERSIST_SIMULATION_INFO, {
            isSimulation: true,
            simulationHeader: simulationHeader,
          })
        );

        if (!stopPropogation)
          if (enforceToSignForms || data?.profile?.userType === `AppointmentInitiator`) {
            navigationHelper.goToActivePage(`accountdetails`, taxId, accessLevel, userId, queryParams, configs);
          } else if (!path && data.profile.assignedAgents) {
            browserHistory.push('/apps/ptb/switchbroker');
          } else if (path && taxId) {
            navigationHelper.goToActivePage(path, taxId, accessLevel, userId, queryParams, configs);
          } else {
            navigationHelper.goToHomePage(taxId, accessLevel, userId, configs);
          }

        return data;
      });
  };
}

export function fetchSelectedPrimary(taxId) {
  return dispatch =>
    Axios.post('/apps/ptb/api/switchbroker', { taxId }).then(selectedPrimaryProfile => {
      // storing accessModules
      // const { accessLevel, userType } = selectedPrimaryProfile.profile;
      // const { type } = selectedPrimaryProfile.profile.producer;
      // const accessModules = ACL.accessControlList(accessLevel, userType, type);
      // dispatch(updateComponentState(ActionTypes.USER_ACCESS_LEVELS, { userAccessModules: accessModules }));

      dispatch(updateComponentState(ActionTypes.SWITCH_ASSIGNED_BROKER, { data: selectedPrimaryProfile }));

      return selectedPrimaryProfile;
    });
}

export function fetchClientConfig() {
  return dispatch => {
    Axios.get('/apps/ptb/api/config')
      .then(data => {
        dispatch(updateComponentState(ActionTypes.HOME_CLIENT_CONFIG, { config: { data: data } }));
      })
      .catch(error => {
        dispatch(updateComponentState(ActionTypes.HOME_CLIENT_CONFIG_FETCH_ERROR, { config: { error: error } }));
      });
  };
}

export function fetchErrorMap() {
  return dispatch => {
    Axios.get('/apps/ptb/api/errorMap')
      .then(data => {
        dispatch(updateComponentState(ActionTypes.HOME_ERRORMAP_CONFIG, { errorMap: { data: data } }));
      })
      .catch(error => {
        dispatch(updateComponentState(ActionTypes.HOME_ERRORMAP_CONFIG_FETCH_ERROR, { errorMap: { error: error } }));
      });
  };
}

export function updateHippaUserProfile() {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.UPDATE_HIPPA_USER_PROFILE, { profileValue: data }));
  };
}

const isProducerLicenseDetailsValid = userProfile => {
  const producerInfo = userProfile?.profile?.producer;
  return (
    Object.keys(producerInfo?.lineOfBusiness)?.length &&
    producerInfo?.appointedStates.length &&
    producerInfo?.actvLcnsInd?.toUpperCase() === 'Y' &&
    producerInfo?.actvRltnshpInd?.toUpperCase() === 'Y'
  );
};

export function getUserProfileList(simulatedUserDetails) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.USER_SIMULATION_DATA, { simulatedUserDetails }));
  };
}
export function setMultipleDelegate(showMutipleDeleagtes) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SET_MULTIPLE_DELEGATE, { showMutipleDeleagtes }));
  };
}
export function getUserList(userList) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.GET_USER_LIST, { userList }));
  };
}
export function fetchUserProducerDetails(taxId) {
  const reqBody = { produceIdentifier: taxId };
  return dispatch => {
    return Axios.post(`/apps/ptb/api/v2/producer/details`, reqBody)
      .then(data => {
        dispatch(updateComponentState(ActionTypes.FETCH_USER_PRODUCER_DATA, data.payLoad));
      })
      .catch(error => {
        console.log(error, 'fetchUserProducerDetails error');
      });
  };
}
export const updateSETEligibilityAccess = flag => {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.UPDATE_SET_SITE_ACCESS_FLAG, flag));
  };
};

export function updateContactInformation(body) {
  return dispatch => {
    const url = `/apps/ptb/api/lastContactUpdate`;

    return Axios.post(url, body)
      .then(data => {
        dispatch(updateComponentState(ActionTypes.UPDATE_CONTACT_INFO, { statusContactInfo: data }));
        return data; 
      })
  };
}
